import { CommentType } from './comment';
import { RenderedContent } from './rendered-content';
import { User } from './user';

export type BBTaskState = 'RESOLVED' | 'UNRESOLVED';

export type BBTask = {
  id: number;
  state: BBTaskState;
  content: RenderedContent;
  links: {
    self: {
      href: string;
    };
    html: {
      href: string;
    };
  };
  comment?: {
    id: CommentType['id'];
    links: CommentType['links'];
  };
  creator?: User | null;
  created_on: string;
  updated_on: string;
  pending?: boolean;
};

declare global {
  namespace BB {
    type Task = BBTask;
    type TaskState = BBTaskState;
  }
}

export type Task = BBTask;
export type TaskState = BBTaskState;
